import React, { PropsWithChildren } from 'react';
import { Paper, Stack, SxProps, Theme } from '@mui/material';

interface ButtonRowProps {
  sx?: SxProps<Theme>;

  orientation: 'horizontal' | 'vertical';
  wrap?: boolean;
}

interface ToolbarProps extends PropsWithChildren<ButtonRowProps> {
  sx?: SxProps<Theme>;
  buttonRowSx?: SxProps<Theme>;

  elevation?: number;
}

export function ToolbarBase(props: ToolbarProps) {
  const { sx, buttonRowSx, children, elevation, ...buttonRowProps } = props;

  if (React.Children.count(children) === 0) return null;

  return (
    <Paper elevation={elevation ?? 0} sx={[{ padding: 1 }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <ToolbarButtonRow {...buttonRowProps} sx={buttonRowSx}>
        {children}
      </ToolbarButtonRow>
    </Paper>
  );
}

export function ToolbarButtonRow(props: PropsWithChildren<ButtonRowProps>) {
  const { sx, children, orientation, wrap = false } = props;

  return (
    <Stack
      direction={orientation === 'horizontal' ? 'row' : 'column'}
      spacing={0.5}
      sx={[
        {
          alignItems: 'center',
          flexWrap: wrap ? 'wrap' : 'nowrap',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Stack>
  );
}
